import React from 'react';
import { PropTypes } from 'prop-types';

const ActiveChip = ({
  isActive
}) => (
  isActive !== null && <span className={ `chip ${ isActive ? 'chip--active' : 'chip--inactive' }` }>{ isActive ? 'ACTIVE' : 'INACTIVE' }</span>
);

ActiveChip.propTypes = {
  isActive: PropTypes.bool,
};

ActiveChip.defaultProps = {
  isActive: null
};

export default ActiveChip;
